import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { Col, Form, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import * as Yup from "yup"
import ModalComponent from "../../components/Modal"
import { admin } from "../../config/apiEndpoints"
import axiosProvider from "../../lib/AxiosProvider"
import CustomSelect from "../../components/CustomSelect"

const BookingCancellation = ({
  isUpdate,
  setData,
  setIsUpdate,
  show,
  fetchData,
  handleClose,
}) => {
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    reason: Yup.object().required("Reason is required"),
  })

  const handleSubmit = async (values, { resetForm }) => {
    try {
      let data = {
        reason: values?.reason?.label,
      }

      const response = await axiosProvider({
        method: "PATCH",
        endpoint: admin.cancelBooking + isUpdate?.id,
        data,
      })

      if (response?.data?.code === 201 || response?.data?.code === 200) {
        toast.success(response.data.message)
        setLoading(false)
        setData((prevData) =>
          prevData.map((item) =>
            item.id === isUpdate?.id
              ? {
                  ...item,
                  ...response.data.data,
                }
              : item
          )
        )
        handleClose()
        setIsUpdate(false)
        resetForm()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: {
      reason: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const reasonList = [
    { label: "Technical Issues", value: "Technical Issues" },
    { label: "Power Issues", value: "Power Issues" },
    { label: "Booking or System Issues", value: "Booking or System Issues" },
    { label: "Maintenance", value: "Maintenance" },
  ]

  const { errors, values, touched, setFieldValue, resetForm } = formik

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        backdrop="static"
        animationFade={true}
        onHide={() => {
          handleClose()
          resetForm()
        }}
        loading={loading}
        modeltitle={"Cancel Booking"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="dark" />
          ) : (
            "Submit"
          )
        }
        btnclosetext="Cancel"
        handleSubmit={formik.handleSubmit}
        children={
          <Form noValidate>
            <Row xs={"auto"}>
              <Col xs={12}>
                <label>
                  Connector Type<span className="required_star">*</span>
                </label>
                <CustomSelect
                  options={reasonList}
                  value={values?.reason}
                  handleSelectChange={(selectconnector) => {
                    setFieldValue("reason", selectconnector)
                  }}
                  isMulti={false}
                  placeholder={"Select Reason"}
                />
                {touched?.reason && errors?.reason && (
                  <p className="invalid_error">{errors?.reason}</p>
                )}
              </Col>
            </Row>
          </Form>
        }
      />
    </>
  )
}

export default BookingCancellation
